import React from "react";
import classNames from "classnames";
import { Button, Icon } from "components";
import { useTranslation } from "hooks";
import { AppContext } from "pages/app/duck/context";
import { Loader } from "./components";
import styles from "./ShowPin.module.css";

const FACTOR = 10;
const TIME = FACTOR * 20;
const MAX_VALUE = 100;

const ShowPin: React.FC = () => {
  const { t } = useTranslation();
  const { pin } = React.use(AppContext);
  const [show, setShow] = React.useState<boolean>(false);
  const [value, setValue] = React.useState<number>(0);
  const [timer, setTimer] = React.useState(TIME);
  const intervalId = React.useRef(0);

  const clear = (): void => {
    window.clearInterval(intervalId.current);
    setShow(false);
    setTimer(TIME);
  };

  React.useEffect(() => {
    return () => clear();
  }, []);

  React.useEffect(() => {
    if (timer <= 0) {
      clear();
    } else {
      setValue(Math.ceil((MAX_VALUE / TIME) * (TIME - timer)));
    }
  }, [timer]);

  const showHandler = (): void => {
    if (show) {
      clear();
    } else {
      setShow(true);
      intervalId.current = window.setInterval(() => {
        setTimer((time) => time - 1);
      }, 1000 / FACTOR);
    }
  };

  return (
    <div className={styles.pinWrapper}>
      <Button
        prefix={
          <Icon
            name={show ? "eye-invisible-outlined" : "eye-outlined"}
            size="small"
          />
        }
        size="small"
        className={styles.showPin}
        prefixClassName={styles.prefixIcon}
        onClick={showHandler}
      >
        {show ? t("offline.hidePin") : t("offline.showPin")}
      </Button>
      <div
        className={classNames(styles.pinContainer, {
          [styles.show]: show,
        })}
      >
        {pin}
        <Loader value={value} size={18} />
      </div>
    </div>
  );
};

export default ShowPin;
